/*
 * Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author Hyeongjin Oh
 * @contact hjoh@detech.co.kr
 * @date 2022-05-25
 * @brief EHP 패이징네이션 컴포넌트
 *
 ********************************************************************/
import React, { useEffect, useState } from "react";
//
import { useTrans } from "../../../utils/langs/useTrans";
/**
 * @brief EHP 패이징네이션 컴포넌트
 * @param -
 * @returns react components
 */
function EhpPagination(props) {
    const t = useTrans();
    //
    const componentName = props.componentName;
    const pageInfo = props.pageInfo;
    const setParentCurPage = props.handleFunc;
    const [directPage, setDirectPage] = useState(0);
    const curPage = pageInfo.number;
    const totalCount = pageInfo.totalElements;
    const listSize = pageInfo.size;
    const lastPage = pageInfo.totalPages;
    const pageSize = (pageInfo.hasOwnProperty("psize")) ? pageInfo.psize : 10;
    const endPage = (pageInfo.totalPages % pageSize === 0) ? 1 : 0;
    const dispLabel = (props.hasOwnProperty("dispLabel")) ? props.dispLabel : t("LABEL.검색결과");
    useEffect(() => {
        setDirectPage(curPage + 1);
    }, [curPage]);
    const pages = [];
    let totalPageSize = Math.ceil(totalCount / listSize);
    let startPage = (curPage <= 0) ? 0 : Math.floor(curPage / pageSize) * pageSize;
    for (let i = 0; i < totalPageSize; i++) {
        if (i >= pageSize)
            break;
        if ((i + startPage) >= totalPageSize)
            break;
        pages.push(i + startPage);
    }
    /*
    clog("IN PAGE : PAGES PS: " + pageSize + " / SP : " + startPage + " / T : " + totalCount
                    + " / C : " + curPage + " / LC : " + listSize
                    + " / PL : " + pages.length + " / PT : " + totalPageSize);
                    */
    function onClickPage(e) {
        var actTag = (e.target.tagName == "LI") ? e.target : e.currentTarget;
        setParentCurPage(actTag.value);
    }
    function onChangePage(e) {
        var actTag = e.target;
        setDirectPage(actTag.value);
        setParentCurPage(actTag.value - 1);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "tbl__bottom", style: { "cursor": "default" } },
            React.createElement("p", { className: "result__num" },
                dispLabel,
                " : ",
                React.createElement("span", null, totalCount)),
            React.createElement("div", { id: "focustop", className: "paging" },
                React.createElement("ul", { className: "paging__button", style: { "cursor": "pointer" } },
                    (startPage >= pageSize)
                        ? React.createElement("li", { className: "btn-first", value: 0, onClick: (e) => onClickPage(e) },
                            React.createElement("a", null, "\uB9E8 \uC55E\uC73C\uB85C"))
                        : React.createElement("li", { className: "btn-first disabled" },
                            React.createElement("a", null, "\uB9E8 \uC55E\uC73C\uB85C")),
                    (curPage > 0)
                        ? React.createElement("li", { className: "btn-prev", value: curPage - 1, onClick: (e) => onClickPage(e) },
                            React.createElement("a", null, "\uC774\uC804 \uD398\uC774\uC9C0\uB85C"))
                        : React.createElement("li", { className: "btn-prev disabled" },
                            React.createElement("a", null, "\uC774\uC804 \uD398\uC774\uC9C0\uB85C")),
                    pages.map((page, idx) => (React.createElement("li", { key: "paging_" + componentName + "_" + idx, value: page, onClick: (e) => onClickPage(e) }, (page === curPage)
                        ? React.createElement("a", { className: "active" }, page + 1)
                        : React.createElement("a", { className: "" }, page + 1)))),
                    ((curPage + 1) < totalPageSize)
                        ? React.createElement("li", { className: "btn-next", value: curPage + 1, onClick: (e) => onClickPage(e) },
                            React.createElement("a", null, "\uB2E4\uC74C \uD398\uC774\uC9C0\uB85C"))
                        : React.createElement("li", { className: "btn-next disabled" },
                            React.createElement("a", null, "\uB2E4\uC74C \uD398\uC774\uC9C0\uB85C")),
                    ((Math.floor(curPage / pageSize) + endPage) < Math.floor(totalPageSize / pageSize))
                        ? React.createElement("li", { className: "btn-last", value: lastPage - 1, onClick: (e) => onClickPage(e) },
                            React.createElement("a", null, "\uB9E8 \uB4A4\uC73C\uB85C"))
                        : React.createElement("li", { className: "btn-last disabled" },
                            React.createElement("a", null, "\uB9E8 \uB4A4\uC73C\uB85C"))),
                React.createElement("div", { className: "paging__select" },
                    React.createElement("span", null, "Page"),
                    React.createElement("input", { type: "text", value: directPage, onChange: (e) => onChangePage(e) }),
                    React.createElement("span", null,
                        "/",
                        totalPageSize))))));
}
export default EhpPagination;
